if (!customElements.get('site-header')) {
  class TG_SiteHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tgHeaderShopifyWrapper = document.querySelector(".shopify-section--header");
      //height is 0 when position is set to absolute
      document.documentElement.style.setProperty('--tg-header-height', document.getElementById('Header').offsetHeight + 'px');

      setTimeout(() => {
        document.documentElement.style.setProperty('--tg-header-logo-width', document.querySelector('.Header__LogoWrapper').offsetWidth + 'px');
      },800)

      if(this.getAttribute('data-sticky-header') == "1" && this.tgHeaderShopifyWrapper){
        document.addEventListener("scroll", this.toggleHeaderWrapperClass.bind(this));
      }
    }

    toggleHeaderWrapperClass(){
      let lastKnownScrollPosition = window.scrollY;
      if (lastKnownScrollPosition > 0 && !this.tgHeaderShopifyWrapper.classList.contains("HeaderWrapperSticking")) {
        this.tgHeaderShopifyWrapper.classList.add("HeaderWrapperSticking");
        document.body.style.setProperty('--sticky-header-height', `${this.offsetHeight}px`);
      }
      if (lastKnownScrollPosition <= 0){
        this.tgHeaderShopifyWrapper.classList.remove("HeaderWrapperSticking");
      }
    }

    disconnectedCallback(){
      document.removeEventListener("scroll", this.toggleHeaderWrapperClass.bind(this));
    }
  }
  
  customElements.define('site-header', TG_SiteHeader);
}